<script>
import Vue from 'vue'

export default {
  props: {
    steps: {
      type: Array,
      default: () => [
        {
          loading: true,
          complete: false,
          title: 'Analisando sua solicitação',
          step: 1,
        },
        {
          loading: false,
          complete: false,
          title: 'Consultando a base de dados',
          step: 2,
        },
        {
          loading: false,
          complete: false,
          title: 'Cruzando informações',
          step: 3,
        },
      ],
    },
    title: {
      type: String,
      default: 'Estamos carregando os seus relatórios',
    },
    description: {
      type: String,
      default:
        'Seus relatórios estarão prontos em instantes, mas se quiser, você pode voltar mais tarde e clicar no botão "relatórios" que os mesmos estarão disponíveis na aba "relatórios disponíveis".',
    },
    progressText: {
      type: String,
      default: 'Acompanhe abaixo o andamento:',
    },
    cancelText: {
      type: String,
      default: 'Cancelar solicitação',
    },
    currentStep: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    cancelVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      item: {},
      cancelCallBack: null,
      internalSteps: [],
    }
  },

  watch: {
    steps: {
      handler(newSteps) {
        this.internalSteps = [...newSteps]
      },
      immediate: true,
      deep: true,
    },

    currentStep(newValue) {
      this.updateStepsProgress(newValue)
    },

    visible(newValue) {
      this.busModal.$emit('dialog', newValue)
    },
  },

  created() {
    if (this.bus) {
      this.bus.$on('dialog', this.open)
    }
  },
  beforeDestroy() {
    if (this.bus) {
      this.bus.$off('dialog', this.open)
    }
  },

  methods: {
    clear() {
      this.item = {}
      this.cancelCallBack = null
      this.resetSteps()
    },

    resetSteps() {
      this.internalSteps = this.internalSteps.map((step, i) => ({
        ...step,
        loading: i === 0,
        complete: false,
      }))
    },

    updateStepsProgress(currentStep) {
      this.internalSteps.forEach((step, index) => {
        step.loading = index === currentStep - 1
        step.complete = index < currentStep - 1
      })

      // Auto close when all steps are complete
      if (currentStep >= this.internalSteps.length) {
        setTimeout(() => {
          this.busModal.$emit('dialog', false)
          this.$emit('completed')
          this.resetSteps()
        }, 1500)
      }
    },

    open({ item = {}, steps = null, title = null, description = null } = {}) {
      this.clear()

      if (steps) {
        this.internalSteps = [...steps]
      }

      this.item = { ...(item || {}) }
      this.cancelCallBack = item.callBack

      this.$nextTick(() => {
        this.busModal.$emit('dialog', true)
      })
    },

    stopRequest() {
      if (this.cancelCallBack) {
        this.cancelCallBack()
      }

      this.$emit('cancelled')

      setTimeout(() => {
        this.busModal.$emit('dialog', false)
        this.resetSteps()
      }, 500)
    },
  },
}
</script>

<template>
  <BaseModal
    :bus="busModal"
    persistent
    centerScreen
    centerAndDecreasesPadding
    closeColor="#8E8E8E"
    backgroundColor="white"
  >
    <template v-slot:title>
      <div class="pl-5 pt-5 ml-5 d-flex align-center">
        <h1 class="m-0 text-md font-regular">
          {{ title }}
        </h1>
      </div>
    </template>

    <div class="pl-10 pr-10 mt-5">
      <p class="font regular text-xs text-color-5e">
        {{ description }}
      </p>

      <div>
        <p class="font regular text-xs text-color-5e">
          {{ progressText }}
        </p>

        <div
          v-for="(stepItem, i) in internalSteps"
          :key="i"
          class="d-flex align-items-center mb-3"
        >
          <div
            class="rounded-circular full-center"
            style="width: 15px; height: 15px; position: relative"
            :style="{
              border:
                !stepItem.loading && !stepItem.complete
                  ? '1px solid #8e8e8e'
                  : 'none',
            }"
          >
            <icon-svg
              v-if="stepItem.complete"
              name="check-circle"
              size="17"
              color="#4CAF50"
              style="position: absolute"
            />
            <base-loading
              v-else-if="stepItem.loading"
              loading
              :size="15"
              minHeight="15px"
              style="position: absolute"
            />
          </div>
          <div class="ml-2 text-xs font-regular text-dark">
            Etapa {{ stepItem.step }}: {{ stepItem.title }}
          </div>
        </div>
      </div>
    </div>

    <template v-if="cancelVisible" v-slot:actions>
      <v-spacer />
      <BaseButton small underlined @click="stopRequest">
        {{ cancelText }}
      </BaseButton>
    </template>
  </BaseModal>
</template>


